export class PatientOption {
  constructor(
    public name: string,
    public selected: boolean,
  ) {
  }
}
